import { LinearProgress, Typography } from '@material-ui/core'
import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { HighlightT } from '../../components/TextHighlighter'
import { ViewMode } from '../../viewTypes'
import ExternalListPageItem from './ExternalListPageItem'
import { ExternalItemList_data } from '../../__generated__/ExternalItemList_data.graphql'

interface Props {
  items: ExternalItemList_data['externalItemList']['items']
  viewMode: ViewMode
  highlights?: HighlightT[]
  isLoadingNext: boolean
}

const NoResultsText = styled(Typography)`
  color: ${(props) => props.theme.palette.grey[300]};
  text-align: center;
  padding: 32px;
  padding-bottom: 8px;
  font-weight: 700;
`
const ResetFiltersLink = styled(Link)`
  text-decoration: none;
  display: block;
  text-align: center;
`

const ExternalItemListContent: React.FC<Props> = ({ items, viewMode, isLoadingNext, highlights }) => {
  return (
    <>
      {items && items.edges && items.edges.length > 0 ? (
        <>
          {items.edges.map((edge) => {
            const item = edge && edge.node
            if (item) return <ExternalListPageItem key={item.slug} listItem={item} viewMode={viewMode} highlights={highlights} />
            return <></>
          })}
          {isLoadingNext && <LinearProgress />}
        </>
      ) : (
        <>
          <NoResultsText variant='h5'>No results</NoResultsText>
          <ResetFiltersLink to={`${window.location.pathname}`}>Reset Filters</ResetFiltersLink>
        </>
      )}
    </>
  )
}

export default ExternalItemListContent
